import { PaymentMethodFilter } from './payment-method-filter';
import { PaymentDateFilter } from './payment-date-filter';
import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { createdAtFilterConfig } from '../../../configs/created-at-filter-config';

export function PaymentFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <PaymentMethodFilter />
      <PaymentDateFilter />
      <InputFilterTrigger
        filterLabel='Created At'
        config={createdAtFilterConfig}
      />
    </div>
  );
}
